import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';

import LRS from '../../utils/LRS';
import ModuleActions from '../../actions/ModuleActionCreator';
import { ModuleDialogs } from '../../constants/Dialogs';
import { openDialog } from '../../actions/DialogActionCreator';

class Launcher extends Component {

    constructor(props) {
        super(props);
        this.handleLaunch = this.handleLaunch.bind(this);
        this.launch = this.launch.bind(this);
    }

    getLaunchAction() {

        if (!!this.props.data.loading) { return null; }
        if (!this.props.data.uuid) { return null; } // do not show launch button for unpublished media
        if (this.props.data.status === 'completed') { return null; }

        if (this.props.data.status !== 'enrolled' && !this.props.data.isAssigned) { return null; }

        switch (this.props.data.complete) {
            case 'pending':
            case 'failed':
            case 'complete':
                return null;

            default: // null, unknown, incomplete
                if (!!this.props.data.registrationId) {
                    return (this.props.data.registrationId !== 'failed' && this.props.data.registrationId !== 'pending' && this.handleLaunch);
                } else if (!this.registrationInProgress) {
                    ModuleActions.createRegistration(this.props.data.moduleId, this.context.auth.identity.id);
                    this.registrationInProgress = true;
                }
                return null;
        }
    }

    launch() {
        let launchUrl = `/elearning/media/${this.props.data.registrationId}/launch/`;
        // this will need some adjustment later - do we still need this?
        if (!!this.props.courseId) {
            launchUrl += `${this.props.courseId}/course`;
            if (!this.props.designated) { launchUrl += `/${this.props.data.moduleId}`; }
        } else {
            launchUrl += `${this.props.data.moduleId}/module`;
        }
        openDialog(ModuleDialogs.ELEARNING_DIALOG, {launchUrl, tinCanId: this.props.data.tinCanId, moduleId: this.props.data.moduleId, asPopup: !!this.props.asPopup});
    }

    handleLaunch(event, reset) {
        LRS.saveLaunchCourseStatement(
            this.context.auth.getCurrentUser(),
            this.props.courseId,
            this.props.courseName,
            this.props.data.tinCanId,
            this.launch
        );
        if (!!this.props.onLaunch) { this.props.onLaunch(this.props); }
    }

    render() {
        return null;
    }
}

Launcher.contextTypes = {
    auth:   PropTypes.object.isRequired
};

Launcher.propTypes = {
    data:       PropTypes.shape({
        moduleId:       PropTypes.number.isRequired,
        registrationId: PropTypes.string,
        tinCanId:       PropTypes.string,
        status:         PropTypes.string,
        isAssigned:     PropTypes.bool
    }).isRequired,
    // optional parameters:
    asPopup:        PropTypes.bool,
    label:          PropTypes.string,
    onLaunch:       PropTypes.func,
    courseId:       PropTypes.number,
    courseName:     PropTypes.string,
    designated:     PropTypes.bool
};

Launcher.defaultProps = {
    label:            'Launch',
    asPopup: false,
};

class ButtonLauncher extends Launcher {
    render() {
        const launchAction = this.getLaunchAction();
        if (!launchAction) { return null; }

        return (
            <RaisedButton
                className="button-raised"
                fullWidth={true}
                primary={true}
                label={this.props.label}
                onTouchTap={launchAction}
            />
        );
    }
}

export default Launcher;
export const LauncherButton = (props) => <ButtonLauncher {...props}/>;

// repeated for autocomplete
LauncherButton.propTypes = {
    data:       PropTypes.shape({
        moduleId:       PropTypes.number.isRequired,
        registrationId: PropTypes.string,
        tinCanId:       PropTypes.string,
        status:         PropTypes.string,
        isAssigned:     PropTypes.bool
    }).isRequired,
    // optional parameters:
    asPopup:        PropTypes.bool,
    label:          PropTypes.string,
    onLaunch:       PropTypes.func,
    courseId:       PropTypes.number,
    courseName:     PropTypes.string,
    designated:     PropTypes.bool
};
